import * as React from 'react';
import { FormattedMessage, legals } from '../../localization/index';
import './ModalConfirmationGR.scss';
import { ExtraDisclaimers } from 'ouisys-component-library';
import { useRootContext } from '../../providers/RootContext';

const ModalConfirmationGR = ({ onClickYes }) => {
  const { locale, defaultFlow } = useRootContext();

  return (
    <div className="ModalConfirmationGR">
      <div className="ModalConfirmationGR-content">
        <div className={`terms service-${process.env.service} compliant`}>
          <ExtraDisclaimers className="disclaimer" locale={locale} legals={legals} flow={defaultFlow} />
        </div>
        <button className="btn" onClick={onClickYes}>
          <FormattedMessage id="moYesButton" defaultMessage="Yes" />
        </button>
      </div>
    </div>
  );
};

export default ModalConfirmationGR;
